import { render, staticRenderFns } from "./userDialogContent.vue?vue&type=template&id=31310154"
import script from "./userDialogContent.vue?vue&type=script&lang=js"
export * from "./userDialogContent.vue?vue&type=script&lang=js"
import style0 from "./userDialogContent.vue?vue&type=style&index=0&id=31310154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports